import { render, staticRenderFns } from "./gc-edit-delivery-address.vue?vue&type=template&id=058c5dc8"
import script from "./gc-edit-delivery-address.vue?vue&type=script&lang=js"
export * from "./gc-edit-delivery-address.vue?vue&type=script&lang=js"
import style0 from "./gc-edit-delivery-address.vue?vue&type=style&index=0&id=058c5dc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports